import CardValidator from 'card-validator';
import max from 'lodash/max';

import { CUSTOM_CVV_LENGTH, DEFAULT_CVV_LENGTH } from '@/core/payment-card/constants/cvv';

/**
 * Gets CVV available lengths, according to card number
 */
export function getCardCodeSizes(cardNumber: string): number | number[] {
    if (!cardNumber) {
        return DEFAULT_CVV_LENGTH;
    }

    const numberValidation = CardValidator.number(cardNumber);

    if (numberValidation.card) {
        return CUSTOM_CVV_LENGTH[numberValidation.card.type] || numberValidation.card.code.size;
    }

    return DEFAULT_CVV_LENGTH;
}

export function getMaximumCvvLength(cardNumber: string): number {
    const sizes = getCardCodeSizes(cardNumber);

    return Array.isArray(sizes) ? max(sizes) : sizes;
}
